<template>
    <div class="page">
        <div class="content">
            <!-- <div class="top">
                <span>主题风格</span>
                <el-button type="primary" size="small" @click="save" :disabled="!CheckItem.id">保存</el-button>
            </div> -->
            <div class="button" style="position: relative">
                <el-button type="primary" style="margin-bottom: 10px" size="small" @click="openShow">主题管理</el-button>
                <div class="button_top">
                    <el-button @click="checkAll(item)" :style="{'background-color':colors == item.id ? '#ecf5ff' : '','width': '124px','height': '44px','padding': '0','margin': '0 20px 10px 0'}" v-for="item in ListAll" :key="item.id">
                        <div style="display: flex;justify-content: center;align-items: center;">
                            <div class="quare" :style="{'background-color': item.subjectColor}"></div>
                            <span>{{item.subjectName}}</span>
                        </div>
                    </el-button>
                </div>
                <div style="margin-top: 30px;height: calc(100% - 195px);position: relative;overflow-y: auto;">
                    <el-image
                        v-for="item in CheckItem.screenShot"
                        v-if="CheckItem.screenShot.length > 0"
                        style="width: 256px;height: 512px;margin-right: 1%;"
                        :src="item">
                    </el-image>
                    <!-- <el-image v-for="url in urls" :key="url" :src="url" lazy></el-image> -->
                    <!-- http://demo.api.hfyefan.cn/image/view/2024-01-23/d80ca60302044120b29fe272d660b5ba.jpg -->
                    <!-- <img v-if="CheckItem.screenShot" style="width: 300px; max-height: 100%;" :src="CheckItem.screenShot" alt="这是一张图片"> -->
                </div>
                <el-button style="margin-top: 12px;position: absolute;height: 40px;width: 84px;bottom: 10px;font-size: 14px" type="primary" size="small" @click="save" :disabled="!CheckItem.id">保存</el-button>
            </div>
        </div>
        <el-drawer
            title="主题管理"
            :visible.sync="isShow"
            direction="rtl"
            size="70%"
            :before-close="closeShow">
            <MppAppSubject ref='mppAppSubject'></MppAppSubject>
        </el-drawer>
    </div>
</template>
<script>
import { exprotExcel, importTemplate, importDate, get, post, put, deleteFun } from '@/utils/request.js';
import MppAppSubject from '@/components/system/MppAppSubject.vue';
export default {
    components:{
        MppAppSubject
    },
    data(){
        return{
            ListAll:[],
            CheckItem:{},
            isShow: false,
        }
    },
    computed:{
        colors(){
            return this.CheckItem.id
        }
    },
    created(){
        this.getAllList();
    },
    methods:{
        getAllList(){
            get(`/mpp/appsubject/findAll`).then(res => {
            if(res.success){
                this.ListAll = res.list;
                for (const iterator of this.ListAll) {
                    iterator.screenShot = iterator.screenShot.split('|');
                    if(iterator.isActive == 1){
                        this.checkAll(iterator);
                    }
                }
            }else{
                this.$message.error(res.msg);
            }
            });
        },
        openShow(){
            this.isShow = true
            this.$nextTick(()=>{
                this.$refs.mppAppSubject.init()
            })
        },
        closeShow(){
            this.isShow = false
            this.getAllList();
        },
        checkAll(val){
            this.CheckItem = val;
            console.log(this.CheckItem)
        },
        save(){
            this.CheckItem.isActive = 1
            let obj = JSON.parse(JSON.stringify(this.CheckItem));
            obj.screenShot = obj.screenShot.join('|');
            post(`/mpp/appsubject/edit`, { ...obj }).then((res) => {
                if (res.success) {
                    this.$message({
                        message: res.msg,
                        type: 'success',
                        duration: 2000
                    });
                    this.getAllList()
                } else {
                    this.$message({
                        message: res.msg,
                        type: 'error',
                        duration: 2000
                    });
                }
            });
        }
    }
}
</script>
<style lang="scss" scoped>
    .page{
        .content{
            padding: 16px 0 16px 16px;
            display: flex;
            flex-direction: column;
            .top{
                width: 100%;
                height: 60px;
                background-color: #fff;
                border-radius: 5px;
                font-size: 14px;
                margin-bottom: 15px;
                display: flex;
                align-items: center;
                justify-content: space-between;
                padding: 0 20px;
                span{
                    font-size: 22px;
                    // font-weight: 700;
                    display: inline-block;
                    color: #17233d;
                    font-weight: 500;
                }
            }
            .button{
                height: calc(100% - 15px);
                background-color: #fff;
                border-radius: 5px;
                padding: 40px 40px 0;
                .quare{
                    width: 25px;
                    height: 25px;
                    border-radius: 5px;
                    margin-right: 6px
                }
                .card{
                    border: solid 1px #e5e5e5;
                    height: 46px;
                    width: 148px;
                    border-radius: 5px;
                }
            }
        }
    }
</style>